import { Formik } from "formik";
import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CRow,
} from "@coreui/react-pro";
import { INewUser, IUser } from "@/shared/model/user.model";
import { ResponseStatus } from "@/shared/enumeration/ResponseStatus";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/reducers";
import * as Yup from "yup";
import { useEffect } from "react";
import { AppDispatch } from "@/store";
import { updateEntity } from "../UserManagement/usersManagement.api";
import { fetching } from "../UserManagement/usersManagement.reducer";
import { formatSTK } from "@/shared/utils/ultils";
import { getProfile } from "../auth/auth.api";
import Header from "./components/Header";

const Bank = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);
  const { initialState } = useSelector(
    (state: RootState) => state.usersReducer
  );
  const { updateEntitySuccess } = initialState;

  const validationSchema = Yup.object().shape({
    bankName: Yup.string()
      .nullable()
      .transform((value) => (value === null ? "" : value))
      .required("Vui lòng nhập tên ngân hàng"),
    cardNumber: Yup.string()
      .nullable()
      .transform((value) => (value === null ? "" : value))
      .required("Vui lòng nhập số tài khoản"),
    cardName: Yup.string()
      .nullable()
      .transform((value) => (value === null ? "" : value))
      .required("Vui lòng nhập chủ tài khoản"),
  });

  const initialValues: INewUser = {
    fullName: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
    phone: "",
    address: "",
    avatar: "",
    avatarColor: "",
    permissionGroupId: "",
    bankName: "",
    cardNumber: "",
    cardName: "",
    paypassword: "",
    invite: "",
    money: 0,
    levelId: 0,
    totalOrder: 0,
    status: ResponseStatus.ACTIVE,
  };

  useEffect(() => {
    if (updateEntitySuccess) {
      dispatch(fetching());
      dispatch(getProfile());
    }
  }, [updateEntitySuccess]);

  return (
    <div className="wrapper">
      <div className="container-web bgnew bank">
        <Header title="Liên kết ngân hàng" />
        <div className="p-3">
          {user?.bankName && user?.cardName && user?.cardNumber ? (
            <div
              className="p-3"
              style={{
                border: "2px solid rgb(222, 169, 79)",
                fontSize: 13,
                color: "rgb(222, 170, 79)",
              }}
            >
              <div className="d-flex mb-1">
                <div className="left" style={{ width: "33%", flexShrink: 0 }}>
                  Ngân hàng
                </div>
                <div className="right">{user?.bankName}</div>
              </div>

              <div className="d-flex mb-1">
                <div className="left" style={{ width: "33%", flexShrink: 0 }}>
                  Chủ tài khoản
                </div>
                <div className="right">{user?.cardName}</div>
              </div>

              <div className="d-flex">
                <div className="left" style={{ width: "33%", flexShrink: 0 }}>
                  Số tài khoản
                </div>
                <div className="right">{formatSTK(user?.cardNumber)}</div>
              </div>
            </div>
          ) : (
            <Formik
              initialValues={user || initialValues}
              validationSchema={validationSchema}
              // validateOnChange={false}
              validateOnBlur={false}
              onSubmit={async (value) => {
                dispatch(fetching());
                if (user) {
                  dispatch(updateEntity(value as IUser));
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
                setFieldValue,
                isSubmitting,
              }) => (
                <CForm onSubmit={handleSubmit} className="custom-form">
                  <CRow className="g-3">
                    <CCol xs="12">
                      <CFormLabel
                        style={{ color: "#deaa4f" }}
                        className="mb-6 label-gray-700"
                      >
                        Tên ngân hàng
                      </CFormLabel>

                      <CFormInput
                        style={{
                          background: "transparent",
                          color: "#fff",
                          borderColor: "#deaa4f",
                        }}
                        className="form-height-44 w-100"
                        name="bankName"
                        type="text"
                        value={values.bankName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!errors.bankName && touched.bankName}
                      />

                      <CFormFeedback
                        invalid
                        className={
                          !!errors.bankName && touched.bankName
                            ? "d-block"
                            : "d-none"
                        }
                      >
                        {errors.bankName}
                      </CFormFeedback>
                    </CCol>

                    <CCol xs={12}>
                      <CFormLabel
                        style={{ color: "#deaa4f" }}
                        className="mb-6 label-gray-700"
                      >
                        Chủ tài khoản
                      </CFormLabel>
                      <CFormInput
                        style={{
                          background: "transparent",
                          color: "#fff",
                          borderColor: "#deaa4f",
                        }}
                        className="form-height-44 w-100"
                        name="cardName"
                        type="text"
                        value={values.cardName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!errors.cardName && touched.cardName}
                      />
                      <CFormFeedback
                        invalid
                        className={
                          !!errors.cardName && touched.cardName
                            ? "d-block"
                            : "d-none"
                        }
                      >
                        {errors.cardNumber}
                      </CFormFeedback>
                    </CCol>

                    <CCol xs={12}>
                      <CFormLabel
                        style={{ color: "#deaa4f" }}
                        className="mb-6 label-gray-700"
                      >
                        Số tài khoản
                      </CFormLabel>
                      <CFormInput
                        style={{
                          background: "transparent",
                          color: "#fff",
                          borderColor: "#deaa4f",
                        }}
                        className="form-height-44 w-100"
                        name="cardNumber"
                        type="text"
                        value={values.cardNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!errors.cardNumber && touched.cardNumber}
                      />
                      <CFormFeedback
                        invalid
                        className={
                          !!errors.cardNumber && touched.cardNumber
                            ? "d-block"
                            : "d-none"
                        }
                      >
                        {errors.cardNumber}
                      </CFormFeedback>
                    </CCol>
                    <CCol>
                      <CLoadingButton
                        type="submit"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        className="w-100 rounded-3 mt-2"
                        style={{
                          background: "rgb(105 86 38)",
                          border: "2px solid #d89239",
                        }}
                      >
                        Liên kết ngân hàng
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                </CForm>
              )}
            </Formik>
          )}
        </div>
      </div>
    </div>
  );
};

export default Bank;
